module.exports = __webpack_public_path__ + "static/media/track.0178f307.svg";